import React, { useEffect, useState, useRef } from 'react';
import { CheckCircle, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const buyers = [{
  name: 'Carlos M.',
  initial: 'C',
  location: 'México',
  time: 'hace 2 min'
}, {
  name: 'Lucía F.',
  initial: 'L',
  location: 'Argentina',
  time: 'hace 5 min'
}, {
  name: 'Diego R.',
  initial: 'D',
  location: 'Colombia',
  time: 'hace 8 min'
}, {
  name: 'Sofía P.',
  initial: 'S',
  location: 'España',
  time: 'hace 12 min'
}, {
  name: 'Andrés V.',
  initial: 'A',
  location: 'Chile',
  time: 'hace 15 min'
}, {
  name: 'Mariana G.',
  initial: 'M',
  location: 'Perú',
  time: 'hace 18 min'
}, {
  name: 'Rafael T.',
  initial: 'R',
  location: 'Venezuela',
  time: 'hace 21 min'
}, {
  name: 'Camila B.',
  initial: 'C',
  location: 'Uruguay',
  time: 'hace 3 min'
}];
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [buyerIndex, setBuyerIndex] = useState(0);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  useEffect(() => {
    let hideTimeout: ReturnType<typeof setTimeout>;
    const showNotification = () => {
      setBuyerIndex(prev => (prev + 1) % buyers.length);
      setIsVisible(true);
      hideTimeout = setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    const initialTimeout = setTimeout(() => {
      setIsVisible(true);
      hideTimeout = setTimeout(() => setIsVisible(false), 5000);
      intervalRef.current = setInterval(showNotification, 30000);
    }, 8000);
    return () => {
      clearTimeout(initialTimeout);
      clearTimeout(hideTimeout);
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);
  const buyer = buyers[buyerIndex];
  return <AnimatePresence data-id="element-368">
      {isVisible && <motion.div initial={{
      x: -320,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -320,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 24
    }} className="fixed bottom-[90px] left-4 z-[200] max-w-[320px] max-sm:left-2.5 max-sm:max-w-[calc(100vw-20px)] max-sm:bottom-[80px]" data-id="element-369">
          <div className="relative bg-white rounded-lg p-3 pr-8 flex items-start gap-3 shadow-[0_4px_12px_rgba(0,0,0,.15),0_0_1px_rgba(0,0,0,.1)]" data-id="element-370">
            {/* Avatar */}
            <div className="relative shrink-0 mt-0.5" data-id="element-371">
              <div className="w-[38px] h-[38px] rounded-full bg-[linear-gradient(135deg,#E8B84B,#C9972B)] flex items-center justify-center text-white font-bold text-base shadow-sm" data-id="element-372">
                {buyer.initial}
              </div>
              <div className="absolute -bottom-0.5 -right-0.5 w-[14px] h-[14px] bg-[#2ecc71] rounded-full flex items-center justify-center border-2 border-white" data-id="element-373">
                <CheckCircle className="w-2 h-2 text-white" data-id="element-374" />
              </div>
            </div>

            {/* Content */}
            <div className="flex-1 min-w-0" data-id="element-375">
              <div className="flex items-center gap-1.5 mb-0.5" data-id="element-376">
                <span className="font-semibold text-[.85rem] text-gray-900 truncate" data-id="element-377">
                  {buyer.name}
                </span>
              </div>
              <div className="text-[.75rem] text-gray-600 leading-snug" data-id="element-378">
                acaba de adquirir{' '}
                <span className="font-medium text-gray-800" data-id="element-379">Código Oscuro</span>
              </div>
              <div className="text-[.7rem] text-gray-400 mt-1 flex items-center gap-1" data-id="element-380">
                {buyer.time} · {buyer.location}
              </div>
            </div>

            {/* Close */}
            <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 transition-colors bg-transparent border-none cursor-pointer p-1" data-id="element-381">
              <X className="w-3.5 h-3.5" data-id="element-382" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}